(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_adac57f"] && !Shopify.designMode) return;
  try {
    (function () {
    var FLAG = 'ri_country_auto';

    function remember() {
      try { localStorage.setItem(FLAG, 'done'); } catch (e) {}
    }

    document.addEventListener('change', function (event) {
      var select = event.target.closest && event.target.closest('[data-country-select]');
      if (!select) return;
      remember();
      select.form.submit();
    });

    function autoSelectCountry() {
      if (window.Shopify && window.Shopify.designMode) return;
      var select = document.querySelector('[data-country-select]');
      if (!select) return;
      try {
        if (localStorage.getItem(FLAG)) return;
      } catch (e) {
        return;
      }
      fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          remember();
          var detected = data && data.detected_values && data.detected_values.country;
          var code = detected && detected.handle;
          if (!code || code === select.value) return;
          var available = Array.prototype.some.call(select.options, function (option) {
            return option.value === code;
          });
          if (!available) return;
          select.value = code;
          select.form.submit();
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoSelectCountry);
    } else {
      autoSelectCountry();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_b8cab0d"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-settings]');
    if (!trigger) return;
    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      event.preventDefault();
      banner.showPreferences();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
